import Vue from 'vue';
import Tooltip from 'primevue/tooltip';

Vue.directive('tooltip', Tooltip);